// extracted by mini-css-extract-plugin
export default {"tag-desc-wrapper":"tag-desc-wrapper_h33HX"};